/** @module Camunda/ProcessLegend */
define([
	"dojo/_base/declare",
	"dijit/_TemplatedMixin",
	"dijit/_WidgetBase",
	"csi/view/ToolbarPlugin",
	"dojo/text!./ProcessLegend.html"
], function(declare,_TemplatedMixin,_WidgetBase,ToolbarPlugin,template) {

	return declare([_WidgetBase, _TemplatedMixin, ToolbarPlugin], {
		baseClass: "csi-camunda-process-legend",
		templateString: template
	});
});
